const Pause = ({ pp }) => {
    return (
        <span className="px-3 py-1 play-btn" title="Pause" style={{ background: "#6842FF" }} onClick={pp}>
            <i className="bi bi-pause-circle-fill"></i>
        </span>
    )
}

export default Pause